export default "__VITE_ASSET__dd17acdc__"